import { PropsWithChildren } from 'react';
import { Box, SxProps, Tooltip } from '@mui/material';
import { FLOW_BUILDER2_PAGE_NS } from '../../i18n';
import { useTranslation } from 'react-i18next';

export interface INameFieldWrapper {
  onClick: (e: React.MouseEvent<HTMLElement>) => void;
  onDoubleClick: (e: React.MouseEvent<HTMLElement>) => void;
  disabled: boolean;
  sx?: SxProps;
}

export const NameFieldWrapper = (props: PropsWithChildren<INameFieldWrapper>) => {
  const { onClick, onDoubleClick, disabled, children, sx = {} } = props;
  const { t } = useTranslation(FLOW_BUILDER2_PAGE_NS);

  return (
    <Tooltip title={disabled ? null : t('tooltips.doubleClickToRename')} placement="top-start">
      <Box
        onDoubleClick={disabled ? undefined : onDoubleClick}
        onClick={disabled ? undefined : onClick}
        sx={{
          cursor: disabled ? 'auto' : 'pointer',
          userSelect: 'none',
          overflow: 'hidden',
          ...sx,
        }}
      >
        {children}
      </Box>
    </Tooltip>
  );
};
